/* eslint-disable no-restricted-imports */
import { useMemo } from 'react';
import { CpaStatus } from '../../../../../data-layer/cpa/types';
import { formatThousandsInt } from '../../../../../utils/format/formatThousands';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Skeleton } from '../../../../feedback/Skeleton';
import { IconQuestionMark } from '../../../../icon/IconQuestionMark';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { useCpaRewardHandlers } from '../../hooks/useCpaRewardHandlers';
import { CpaRewardContentTextProps } from '../../types';

export const CpaRewardContentText = ({
    walletInfo,
    isWalletLoading,
    cpaStatus,
}: CpaRewardContentTextProps) => {
    const t = useTranslation();

    const { openInfoDialog } = useCpaRewardHandlers();

    const textStatus = useMemo(() => {
        switch (cpaStatus) {
            case CpaStatus.DECLINED:
                return <Typography color="var(--warning)">{t('Регистрация отклонена')}</Typography>;
            case CpaStatus.MODERATION:
                return <Typography>{t('Проверяем регистрацию')}</Typography>;
            default:
                return <Typography>{t('Ошибка загрузки')}</Typography>;
        }
    }, [cpaStatus, t]);

    if (isWalletLoading) {
        return (
            <Skeleton
                variant="rect"
                width={130}
                height={24}
                borderRadius={10}
                mt={1}
                dataTestId={DataTestId.CPA_REWARD_CONTENT_TEXT}
            />
        );
    }

    return (
        <Flex
            direction="column"
            spacing={0.125}
            mt={1}
            dataTestId={DataTestId.CPA_REWARD_CONTENT_TEXT}
        >
            <Typography variant="caption" color="secondary">
                {t('Программа вознаграждения')}
            </Typography>
            <Flex direction="row" spacing={0.5} alignItems="center">
                {walletInfo?.balance === undefined ? (
                    textStatus
                ) : (
                    <Flex direction="row" spacing={0.5}>
                        <Typography>{t('Награда:')}</Typography>
                        <Typography weight="bold">{`${formatThousandsInt(
                            walletInfo.balance,
                        )} ₽`}</Typography>
                    </Flex>
                )}

                <IconQuestionMark
                    width={16}
                    height={16}
                    color="var(--color-primary)"
                    cursor="pointer"
                    fillOpacity={1}
                    onClick={openInfoDialog}
                />
            </Flex>
        </Flex>
    );
};
